import { USER_FILTERS, FILTER_KEYS, SEARCH_DEBOUNCE_TIME } from '../consts';
import useFilters from '../hooks/useFilters';
import ExportDropdown from './ExportDropdown';
import TextInput from './TextInput';
import { debounce } from 'lodash';
import { useMemo, useState } from 'react';
import useFilterSelectors from 'shared/hooks/useFilterSelectors';
import useMobileLayout from 'shared/hooks/useMobileLayout';

function Header() {
  const isMobileLayout = useMobileLayout();
  const { onPartialFilterSelected, onFiltersDeleted } = useFilterSelectors();

  const { senderShareId, recipientShareId, premoId, orderId, mPayReference } = useFilters();

  const [selectedOption, setSelectedOption] = useState(FILTER_KEYS.orderId);

  const debouncedPartialSelectCallback = useMemo(
    () => debounce(onPartialFilterSelected, SEARCH_DEBOUNCE_TIME),
    [onPartialFilterSelected]
  );

  return (
    <div className="py-4 flex flex-col w-full gap-10">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between sm:gap-10">
        <div className="font-klarheit tracking-tight text-4xl whitespace-nowrap text-right sm:text-left">
          Gift Card Orders
        </div>
        <div className={`flex ${isMobileLayout ? 'w-full justify-end' : ''}`}>
          <ExportDropdown />
        </div>
      </div>
      <div className={`w-full flex justify-between ${isMobileLayout ? 'flex-col gap-4' : 'flex-row gap-8'}`}>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col items-start sm:flex-row sm:items-center gap-4">
            {USER_FILTERS.map((option) => (
              <div key={option.id} className="flex gap-1.5 items-center">
                <input
                  type="radio"
                  id={option.id}
                  name="option"
                  value={option.id}
                  checked={selectedOption === option.id}
                  onChange={() => setSelectedOption(option.id)}
                  className="text-palette-burgundy focus:ring-palette-burgundy checked:bg-none"
                />
                <label htmlFor={option.id} className="font-semibold text-sm text-nowrap whitespace-nowrap">
                  {option.label}
                </label>
              </div>
            ))}
          </div>
          {selectedOption === FILTER_KEYS.orderId ? (
            <TextInput
              initValue={orderId}
              placeholder="Search Order ID"
              onUpdate={(value) =>
                debouncedPartialSelectCallback({
                  [FILTER_KEYS.mPayReference]: '',
                  [FILTER_KEYS.recipientShareId]: '',
                  [FILTER_KEYS.senderShareId]: '',
                  [FILTER_KEYS.premoId]: '',
                  [FILTER_KEYS.orderId]: value,
                })
              }
              onClear={() => onFiltersDeleted(FILTER_KEYS.orderId)}
            />
          ) : selectedOption === FILTER_KEYS.senderShareId ? (
            <TextInput
              initValue={senderShareId}
              placeholder="Search Sender SHARE ID"
              onUpdate={(value) =>
                debouncedPartialSelectCallback({
                  [FILTER_KEYS.mPayReference]: '',
                  [FILTER_KEYS.recipientShareId]: '',
                  [FILTER_KEYS.senderShareId]: value,
                  [FILTER_KEYS.orderId]: '',
                  [FILTER_KEYS.premoId]: '',
                })
              }
              onClear={() => onFiltersDeleted(FILTER_KEYS.senderShareId)}
            />
          ) : selectedOption === FILTER_KEYS.recipientShareId ? (
            <TextInput
              initValue={recipientShareId}
              placeholder="Search recipient SHARE ID"
              onUpdate={(value) =>
                debouncedPartialSelectCallback({
                  [FILTER_KEYS.mPayReference]: '',
                  [FILTER_KEYS.recipientShareId]: value,
                  [FILTER_KEYS.senderShareId]: '',
                  [FILTER_KEYS.orderId]: '',
                  [FILTER_KEYS.premoId]: '',
                })
              }
              onClear={() => onFiltersDeleted(FILTER_KEYS.recipientShareId)}
            />
          ) : selectedOption === FILTER_KEYS.premoId ? (
            <TextInput
              initValue={premoId}
              placeholder="Search Premo ID"
              onUpdate={(value) =>
                debouncedPartialSelectCallback({
                  [FILTER_KEYS.mPayReference]: '',
                  [FILTER_KEYS.recipientShareId]: '',
                  [FILTER_KEYS.senderShareId]: '',
                  [FILTER_KEYS.orderId]: '',
                  [FILTER_KEYS.premoId]: value,
                })
              }
              onClear={() => onFiltersDeleted(FILTER_KEYS.premoId)}
            />
          ) : selectedOption === FILTER_KEYS.mPayReference ? (
            <TextInput
              initValue={mPayReference}
              placeholder="Search MPay Ref"
              onUpdate={(value) =>
                debouncedPartialSelectCallback({
                  [FILTER_KEYS.mPayReference]: value,
                  [FILTER_KEYS.recipientShareId]: '',
                  [FILTER_KEYS.senderShareId]: '',
                  [FILTER_KEYS.orderId]: '',
                  [FILTER_KEYS.premoId]: '',
                })
              }
              onClear={() => onFiltersDeleted(FILTER_KEYS.mPayReference)}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Header;
